var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M490.08,266.6c.08-1.08.17-2.15.31-3.22,1.49-11.49,8.48-97.87-100-206.5C273.74-59.88,146.3,71.26,124.29,105.54s-28.43,86.91-45.42,52.28c-10.51-21.42,16.87-48.23-21.91-37-24.88,7.18-71.1,70.78-33.22,180S168.05,493.44,270.32,487.36c131.51-7.82,209-103.19,202.8-110.28s-55.13,14.06-44.36-.67C439.35,361.9,487,307.14,490.08,266.6Z",
    style: {
      fill: "#FFFFFF"
    },
    className: "EdzHxLGs_0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.08,266.6c.08-1.08.17-2.15.31-3.22,1.49-11.49,8.48-97.87-100-206.5C273.74-59.88,146.3,71.26,124.29,105.54s-28.43,86.91-45.42,52.28c-10.51-21.42,16.87-48.23-21.91-37-24.88,7.18-71.1,70.78-33.22,180S168.05,493.44,270.32,487.36c131.51-7.82,209-103.19,202.8-110.28s-55.13,14.06-44.36-.67C439.35,361.9,487,307.14,490.08,266.6Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    },
    className: "EdzHxLGs_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 214.83,
    height: 442.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 165.68,32.77 L 346.51,32.77 A 17,17,0,0,1,363.51,49.77 L 363.51,458.04999999999995 A 17,17,0,0,1,346.51,475.04999999999995 L 165.68,475.04999999999995 A 17,17,0,0,1,148.68,458.04999999999995 L 148.68,49.77 A 17,17,0,0,1,165.68,32.77",
    className: "EdzHxLGs_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,53.92H222a11.3,11.3,0,0,1-10.16-6.36l-7.2-14.79H307.56l-7.2,14.79A11.3,11.3,0,0,1,290.2,53.92Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Profile--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 111.18,
    height: 38.98,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M373.68 428.7 L484.86 428.7 L484.86 467.68 L373.68 467.68 Z",
    className: "EdzHxLGs_4"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-91.85 101.49) rotate(-13.21)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M379.49,447.41A12.9,12.9 0,1,1 405.28999999999996,447.41A12.9,12.9 0,1,1 379.49,447.41",
    className: "EdzHxLGs_5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,443.05a5,5,0,1,0-5,5A5,5,0,0,0,397.36,443.05Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.39,449a8.21,8.21,0,0,0-8.22,8.21c0,.06,0,.12,0,.18a12.89,12.89,0,0,0,16.41,0c0-.06,0-.12,0-.18A8.21,8.21,0,0,0,392.39,449Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M416.55,440.68L448.3,440.68",
    className: "EdzHxLGs_8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M416.55,448.28L476.6,448.28",
    className: "EdzHxLGs_9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M416.55,457.44L476.6,457.44",
    className: "EdzHxLGs_10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 44.59,
    height: 26.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M403.03 389.6 L447.62 389.6 L447.62 416.56 L403.03 416.56 Z",
    className: "EdzHxLGs_11"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M403.03,389.6L425.32,404.65L447.62,389.6",
    className: "EdzHxLGs_12"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 45.68,
    height: 43.68,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 442.08,330.95 L 477.76,330.95 A 5,5,0,0,1,482.76,335.95 L 482.76,369.63 A 5,5,0,0,1,477.76,374.63 L 442.08,374.63 A 5,5,0,0,1,437.08,369.63 L 437.08,335.95 A 5,5,0,0,1,442.08,330.95",
    className: "EdzHxLGs_13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M470.64,352.02L452.65,341.64L452.65,362.41L470.64,352.02Z",
    className: "EdzHxLGs_14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 45.68,
    height: 43.68,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 376.51,330.95 L 412.19,330.95 A 5,5,0,0,1,417.19,335.95 L 417.19,369.63 A 5,5,0,0,1,412.19,374.63 L 376.51,374.63 A 5,5,0,0,1,371.51,369.63 L 371.51,335.95 A 5,5,0,0,1,376.51,330.95",
    className: "EdzHxLGs_15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M378.39,367.1L411.15,367.1L399.13,343.97L391.24,360.03L386.1,352.32L378.39,367.1Z",
    className: "EdzHxLGs_16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.69,341.76a6.13,6.13,0,1,0-6.13,6.13A6.12,6.12,0,0,0,392.69,341.76Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cart--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.62,269.84a2.53,2.53,0,0,0-2-1H406v0a12,12,0,0,0-11.53-8.57H388a2.57,2.57,0,0,0,0,5.13h6.42a6.87,6.87,0,0,1,6.63,4.92l7.69,25.55a2.56,2.56,0,0,0,2.45,1.82H443a2.57,2.57,0,0,0,2.5-2L451.11,272A2.55,2.55,0,0,0,450.62,269.84Zm-40.88,11.55h33.88l-.77,3.27H410.73Zm35.63-7.4-.71,3H408.42l-.9-3Zm-32.26,18.57-1.06-3.51h29.76l-.83,3.51Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.54,300.87a4.92,4.92,0,1,0,4.92,4.92A4.93,4.93,0,0,0,417.54,300.87Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.73,300.87a4.92,4.92,0,1,0,4.91,4.92A4.93,4.93,0,0,0,434.73,300.87Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pointer--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.51,301.4,439.26,292A1.76,1.76,0,0,0,437,294l7.52,22a1.76,1.76,0,0,0,2.9.92l3.08-2.82,6.05,6.61a1.37,1.37,0,0,0,1.95.09l5.54-5.06a1.38,1.38,0,0,0,.08-1.95l-6-6.62,3.08-2.81A1.76,1.76,0,0,0,460.51,301.4Z",
    style: {
      fill: "#272069",
      stroke: "#272069",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.93,298.48,438.67,289a1.76,1.76,0,0,0-2.24,2.06l7.51,22a1.77,1.77,0,0,0,2.91.92l3.08-2.82,6,6.61a1.4,1.4,0,0,0,2,.09l5.53-5.07a1.38,1.38,0,0,0,.09-1.95l-6.05-6.61,3.08-2.82A1.75,1.75,0,0,0,459.93,298.48Z",
    style: {
      fill: "#fff",
      stroke: "#272069",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_22"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Button--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.62,67.42H419a16,16,0,0,1-16-16h0a16,16,0,0,1,16-16h41.58a16,16,0,0,1,16,16h0A16,16,0,0,1,460.62,67.42Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_23"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M404.3,51.38A14.26,14.26 0,1,1 432.82,51.38A14.26,14.26 0,1,1 404.3,51.38",
    className: "EdzHxLGs_24"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frames--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    width: 107.91,
    height: 82.56,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M31.56 332.24 L139.47 332.24 L139.47 414.8 L31.56 414.8 Z",
    className: "EdzHxLGs_25"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M31.56,414.8L139.47,332.24",
    className: "EdzHxLGs_26"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M31.56,332.24L139.47,414.8",
    className: "EdzHxLGs_27"
  }), /*#__PURE__*/React.createElement("path", {
    width: 62.33,
    height: 42.7,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M77.14 429.56 L139.47 429.56 L139.47 472.26 L77.14 472.26 Z",
    className: "EdzHxLGs_28"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M77.14,472.27L139.47,429.56",
    className: "EdzHxLGs_29"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M77.14,429.56L139.47,472.27",
    className: "EdzHxLGs_30"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bars--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.92,308.89H35.37a2.9,2.9,0,0,1-2.9-2.9h0a2.9,2.9,0,0,1,2.9-2.9H135.92a2.9,2.9,0,0,1,2.9,2.9h0A2.9,2.9,0,0,1,135.92,308.89Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M114.50999999999999,305.99A6.9,6.9 0,1,1 128.31,305.99A6.9,6.9 0,1,1 114.50999999999999,305.99",
    className: "EdzHxLGs_32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92,288.45H35.37a2.9,2.9,0,0,1-2.9-2.9h0a2.9,2.9,0,0,1,2.9-2.9H135.92a2.9,2.9,0,0,1,2.9,2.9h0A2.9,2.9,0,0,1,135.92,288.45Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_33"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M66.19,285.55A6.9,6.9 0,1,1 79.99000000000001,285.55A6.9,6.9 0,1,1 66.19,285.55",
    className: "EdzHxLGs_34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.92,268H35.37a2.9,2.9,0,0,1-2.9-2.9h0a2.9,2.9,0,0,1,2.9-2.9H135.92a2.9,2.9,0,0,1,2.9,2.9h0A2.9,2.9,0,0,1,135.92,268Z",
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.56,265.12a6.9,6.9,0,1,0-6.9,6.9A6.9,6.9,0,0,0,101.56,265.12Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_36"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-238"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    d: "M296.24,273.18L330.6,309.89",
    className: "EdzHxLGs_37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.59,244.8s.75-6.42,4.29-8.58c7.75-4.72,14-1.95,16.37-3.12s7.41-5.06,9.36-3.11-1.56,5.45-1.56,5.45c-.84.85,10.79,2.08,13.64,0,1-.72,5.85-5.45,7.8-3.12s-1.56,9.36-1.56,9.36-4.29,4.68-8.57,6.63-9.75,3.51-14,3.51S374,250,374,250s-2.25,7.48-11,3.18C357.14,250.35,361.59,244.8,361.59,244.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.06,244.58s5.09-4.07,8.57-4.07,13.38,2.61,14.25,2.9a40.27,40.27,0,0,0,5.24.44s6.83-6,9-6.25,1.69,1.44,1.75,2.76",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.44,239.34s6.69-5.23,8.73-5.09a1.73,1.73,0,0,1,1.6,2.19",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.05,235.44s-1.84,0-3.58-.17-4.07-.43-4.07-.43",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,316.65a5.58,5.58,0,1,0-5.58,5.58A5.58,5.58,0,0,0,344.41,316.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_42"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    d: "M362.33,258.78L342.35,307.25",
    className: "EdzHxLGs_43"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    d: "M215.94,273.18L181.58,309.89",
    className: "EdzHxLGs_44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.59,244.8s-.75-6.42-4.29-8.58c-7.75-4.72-14-1.95-16.37-3.12s-7.41-5.06-9.36-3.11,1.56,5.45,1.56,5.45c.84.85-10.79,2.08-13.64,0-1-.72-5.85-5.45-7.8-3.12s1.56,9.36,1.56,9.36,4.29,4.68,8.58,6.63,9.74,3.51,14,3.51S138.18,250,138.18,250s2.24,7.48,11,3.18C155,250.35,150.59,244.8,150.59,244.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,244.58s-5.08-4.07-8.57-4.07-13.38,2.61-14.25,2.9a40.27,40.27,0,0,1-5.24.44s-6.83-6-9-6.25-1.69,1.44-1.75,2.76",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74,239.34s-6.69-5.23-8.73-5.09a1.73,1.73,0,0,0-1.6,2.19",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.13,235.44s1.84,0,3.58-.17,4.07-.43,4.07-.43",
    style: {
      fill: "none",
      stroke: "#919191",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M167.76999999999998,316.65A5.58,5.58 0,1,1 178.93,316.65A5.58,5.58 0,1,1 167.76999999999998,316.65",
    className: "EdzHxLGs_49"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 7
    },
    d: "M149.85,258.78L169.83,307.25",
    className: "EdzHxLGs_50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.31,282.46l-10.88-10.07L272,278.68a32.9,32.9,0,0,0-9.6-3.69l-.85-9.2-14.82.58-.12,9a33.07,33.07,0,0,0-9.41,4.17l-7.1-5.9L220,284.55l6.3,6.48a33.21,33.21,0,0,0-3.7,9.6l-9.2.85L214,316.3l9,.12a33.07,33.07,0,0,0,4.17,9.41l-5.9,7.1L232.15,343l6.47-6.29a33.64,33.64,0,0,0,9.61,3.69l.84,9.2,14.82-.58.13-9a33.07,33.07,0,0,0,9.41-4.17l7.09,5.9,10.07-10.89-6.29-6.47a33,33,0,0,0,3.69-9.6l9.2-.85-.58-14.82-9-.12a33.31,33.31,0,0,0-4.18-9.42Zm-17.39,40.62a22.66,22.66,0,1,1-1.25-32A22.66,22.66,0,0,1,271.92,323.08Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_51"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-98.99 196.44) rotate(-31.71)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M274.86,272.51A21.51,21.51 0,1,1 317.88,272.51A21.51,21.51 0,1,1 274.86,272.51",
    className: "EdzHxLGs_52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.42,263.11l-4.27-4.91L305,260.64a14.48,14.48,0,0,0-4-2.07l.07-4.06-6.49-.45L294.1,258a14.48,14.48,0,0,0-4.3,1.37L287,256.46l-4.91,4.27,2.44,3.12a14.48,14.48,0,0,0-2.07,4l-4.06-.07-.45,6.49,3.93.49a14.78,14.78,0,0,0,1.37,4.3l-2.91,2.82,4.27,4.91,3.13-2.44a14.42,14.42,0,0,0,4,2.07l-.07,4.06,6.5.45.48-3.93a14.84,14.84,0,0,0,4.31-1.37l2.82,2.91,4.91-4.27-2.44-3.13a14.42,14.42,0,0,0,2.07-4l4.06.07.45-6.5-3.94-.48a14.54,14.54,0,0,0-1.37-4.31ZM302.9,280a9.94,9.94,0,1,1,1-14A9.93,9.93,0,0,1,302.9,280Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_53"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-88.16 441.8) rotate(-81)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M193.03,272.51A21.51,21.51 0,1,1 236.04999999999998,272.51A21.51,21.51 0,1,1 193.03,272.51",
    className: "EdzHxLGs_54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.49,263.11l4.27-4.91,3.12,2.44a14.62,14.62,0,0,1,4-2.07l-.07-4.06,6.5-.45.48,3.94a14.63,14.63,0,0,1,4.31,1.37l2.81-2.91,4.92,4.27-2.44,3.12a14.75,14.75,0,0,1,2.07,4l4.05-.07.46,6.49-3.94.49a14.48,14.48,0,0,1-1.37,4.3l2.91,2.82-4.27,4.91-3.12-2.44a14.62,14.62,0,0,1-4,2.07l.07,4.06-6.5.45-.48-3.93a14.93,14.93,0,0,1-4.31-1.37l-2.81,2.91-4.92-4.27,2.44-3.13a14.42,14.42,0,0,1-2.07-4l-4,.07-.46-6.5,3.94-.48a14.54,14.54,0,0,1,1.37-4.31ZM208,280a9.95,9.95,0,1,0-1-14A9.95,9.95,0,0,0,208,280Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_55"
  }), /*#__PURE__*/React.createElement("path", {
    width: 54.31,
    height: 68.02,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M 238.13,156.14 L 272.44,156.14 A 10,10,0,0,1,282.44,166.14 L 282.44,214.15999999999997 A 10,10,0,0,1,272.44,224.15999999999997 L 238.13,224.15999999999997 A 10,10,0,0,1,228.13,214.15999999999997 L 228.13,166.14 A 10,10,0,0,1,238.13,156.14",
    className: "EdzHxLGs_56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.14,182.71c0,3.2-1.33,5.8-3,5.8s-3-2.6-3-5.8,1.33-5.81,3-5.81S248.14,179.5,248.14,182.71Z",
    style: {
      fill: "#263238"
    },
    className: "EdzHxLGs_57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.28,182.71c0,3.2-1.33,5.8-3,5.8s-3-2.6-3-5.8,1.34-5.81,3-5.81S269.28,179.5,269.28,182.71Z",
    style: {
      fill: "#263238"
    },
    className: "EdzHxLGs_58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,193.6a20,20,0,0,0,36.76,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    className: "EdzHxLGs_59"
  }), /*#__PURE__*/React.createElement("path", {
    width: 90.94,
    height: 85.8,
    style: {
      fill: "#FFFFFF",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M 213.82,235.09 L 296.76,235.09 A 4,4,0,0,1,300.76,239.09 L 300.76,316.89 A 4,4,0,0,1,296.76,320.89 L 213.82,320.89 A 4,4,0,0,1,209.82,316.89 L 209.82,239.09 A 4,4,0,0,1,213.82,235.09",
    className: "EdzHxLGs_60"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    d: "M280.76,277.99L236.83,252.62L236.83,303.35L280.76,277.99Z",
    className: "EdzHxLGs_61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.9,384.47,295.67,369l-9.58,3.3a37.51,37.51,0,0,0-8-8.35l3.54-9.74-15.31-6.51-4.45,9.1a37.53,37.53,0,0,0-11.55-.27L246,347.18l-15.43,6.23,3.29,9.58a37.23,37.23,0,0,0-8.34,8l-9.74-3.55-6.51,15.32,9.1,4.45a37.52,37.52,0,0,0-.27,11.55l-9.38,4.37,6.23,15.43,9.58-3.29a37.06,37.06,0,0,0,8,8.35l-3.55,9.74,15.32,6.51,4.45-9.11a37.15,37.15,0,0,0,11.54.27l4.38,9.39L280,434.17l-3.29-9.58a37.28,37.28,0,0,0,8.35-8l9.74,3.54,6.51-15.31-9.11-4.45a37.22,37.22,0,0,0,.27-11.55Zm-37.1,32.89a25.42,25.42,0,1,1,14.06-33.09A25.41,25.41,0,0,1,264.8,417.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    },
    className: "EdzHxLGs_62"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    "data-made-with": "vivus-instant"
  }, ".EdzHxLGs_0{stroke-dasharray:1650 1652;stroke-dashoffset:1651;animation:EdzHxLGs_draw_0 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_1{stroke-dasharray:1650 1652;stroke-dashoffset:1651;animation:EdzHxLGs_draw_1 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_2{stroke-dasharray:1286 1288;stroke-dashoffset:1287;animation:EdzHxLGs_draw_2 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_3{stroke-dasharray:230 232;stroke-dashoffset:231;animation:EdzHxLGs_draw_3 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_4{stroke-dasharray:301 303;stroke-dashoffset:302;animation:EdzHxLGs_draw_4 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_5{stroke-dasharray:82 84;stroke-dashoffset:83;animation:EdzHxLGs_draw_5 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_6{stroke-dasharray:32 34;stroke-dashoffset:33;animation:EdzHxLGs_draw_6 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_7{stroke-dasharray:44 46;stroke-dashoffset:45;animation:EdzHxLGs_draw_7 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_8{stroke-dasharray:32 34;stroke-dashoffset:33;animation:EdzHxLGs_draw_8 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_9{stroke-dasharray:61 63;stroke-dashoffset:62;animation:EdzHxLGs_draw_9 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_10{stroke-dasharray:61 63;stroke-dashoffset:62;animation:EdzHxLGs_draw_10 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_11{stroke-dasharray:144 146;stroke-dashoffset:145;animation:EdzHxLGs_draw_11 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_12{stroke-dasharray:54 56;stroke-dashoffset:55;animation:EdzHxLGs_draw_12 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_13{stroke-dasharray:171 173;stroke-dashoffset:172;animation:EdzHxLGs_draw_13 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_14{stroke-dasharray:63 65;stroke-dashoffset:64;animation:EdzHxLGs_draw_14 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_15{stroke-dasharray:171 173;stroke-dashoffset:172;animation:EdzHxLGs_draw_15 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_16{stroke-dasharray:103 105;stroke-dashoffset:104;animation:EdzHxLGs_draw_16 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_17{stroke-dasharray:39 41;stroke-dashoffset:40;animation:EdzHxLGs_draw_17 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_18{stroke-dasharray:400 402;stroke-dashoffset:401;animation:EdzHxLGs_draw_18 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_19{stroke-dasharray:31 33;stroke-dashoffset:32;animation:EdzHxLGs_draw_19 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_20{stroke-dasharray:31 33;stroke-dashoffset:32;animation:EdzHxLGs_draw_20 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_21{stroke-dasharray:96 98;stroke-dashoffset:97;animation:EdzHxLGs_draw_21 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_22{stroke-dasharray:96 98;stroke-dashoffset:97;animation:EdzHxLGs_draw_22 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_23{stroke-dasharray:184 186;stroke-dashoffset:185;animation:EdzHxLGs_draw_23 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_24{stroke-dasharray:90 92;stroke-dashoffset:91;animation:EdzHxLGs_draw_24 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_25{stroke-dasharray:381 383;stroke-dashoffset:382;animation:EdzHxLGs_draw_25 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_26{stroke-dasharray:136 138;stroke-dashoffset:137;animation:EdzHxLGs_draw_26 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_27{stroke-dasharray:136 138;stroke-dashoffset:137;animation:EdzHxLGs_draw_27 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_28{stroke-dasharray:211 213;stroke-dashoffset:212;animation:EdzHxLGs_draw_28 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_29{stroke-dasharray:76 78;stroke-dashoffset:77;animation:EdzHxLGs_draw_29 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_30{stroke-dasharray:76 78;stroke-dashoffset:77;animation:EdzHxLGs_draw_30 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_31{stroke-dasharray:220 222;stroke-dashoffset:221;animation:EdzHxLGs_draw_31 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_32{stroke-dasharray:44 46;stroke-dashoffset:45;animation:EdzHxLGs_draw_32 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_33{stroke-dasharray:220 222;stroke-dashoffset:221;animation:EdzHxLGs_draw_33 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_34{stroke-dasharray:44 46;stroke-dashoffset:45;animation:EdzHxLGs_draw_34 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_35{stroke-dasharray:220 222;stroke-dashoffset:221;animation:EdzHxLGs_draw_35 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_36{stroke-dasharray:44 46;stroke-dashoffset:45;animation:EdzHxLGs_draw_36 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_37{stroke-dasharray:51 53;stroke-dashoffset:52;animation:EdzHxLGs_draw_37 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_38{stroke-dasharray:139 141;stroke-dashoffset:140;animation:EdzHxLGs_draw_38 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_39{stroke-dasharray:45 47;stroke-dashoffset:46;animation:EdzHxLGs_draw_39 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_40{stroke-dasharray:14 16;stroke-dashoffset:15;animation:EdzHxLGs_draw_40 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_41{stroke-dasharray:8 10;stroke-dashoffset:9;animation:EdzHxLGs_draw_41 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_42{stroke-dasharray:36 38;stroke-dashoffset:37;animation:EdzHxLGs_draw_42 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_43{stroke-dasharray:53 55;stroke-dashoffset:54;animation:EdzHxLGs_draw_43 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_44{stroke-dasharray:51 53;stroke-dashoffset:52;animation:EdzHxLGs_draw_44 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_45{stroke-dasharray:139 141;stroke-dashoffset:140;animation:EdzHxLGs_draw_45 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_46{stroke-dasharray:45 47;stroke-dashoffset:46;animation:EdzHxLGs_draw_46 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_47{stroke-dasharray:14 16;stroke-dashoffset:15;animation:EdzHxLGs_draw_47 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_48{stroke-dasharray:8 10;stroke-dashoffset:9;animation:EdzHxLGs_draw_48 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_49{stroke-dasharray:36 38;stroke-dashoffset:37;animation:EdzHxLGs_draw_49 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_50{stroke-dasharray:53 55;stroke-dashoffset:54;animation:EdzHxLGs_draw_50 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_51{stroke-dasharray:490 492;stroke-dashoffset:491;animation:EdzHxLGs_draw_51 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_52{stroke-dasharray:136 138;stroke-dashoffset:137;animation:EdzHxLGs_draw_52 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_53{stroke-dasharray:215 217;stroke-dashoffset:216;animation:EdzHxLGs_draw_53 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_54{stroke-dasharray:136 138;stroke-dashoffset:137;animation:EdzHxLGs_draw_54 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_55{stroke-dasharray:215 217;stroke-dashoffset:216;animation:EdzHxLGs_draw_55 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_56{stroke-dasharray:228 230;stroke-dashoffset:229;animation:EdzHxLGs_draw_56 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_57{stroke-dasharray:29 31;stroke-dashoffset:30;animation:EdzHxLGs_draw_57 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_58{stroke-dasharray:29 31;stroke-dashoffset:30;animation:EdzHxLGs_draw_58 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_59{stroke-dasharray:47 49;stroke-dashoffset:48;animation:EdzHxLGs_draw_59 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_60{stroke-dasharray:347 349;stroke-dashoffset:348;animation:EdzHxLGs_draw_60 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_61{stroke-dasharray:153 155;stroke-dashoffset:154;animation:EdzHxLGs_draw_61 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}.EdzHxLGs_62{stroke-dasharray:550 552;stroke-dashoffset:551;animation:EdzHxLGs_draw_62 4200ms linear 0ms infinite,EdzHxLGs_fade 4200ms linear 0ms infinite;}@keyframes EdzHxLGs_draw{100%{stroke-dashoffset:0;}}@keyframes EdzHxLGs_fade{0%{stroke-opacity:1;}90.47619047619048%{stroke-opacity:1;}100%{stroke-opacity:0;}}@keyframes EdzHxLGs_draw_0{19.047619047619047%{stroke-dashoffset: 1651}50.793650793650805%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_1{19.30363543266769%{stroke-dashoffset: 1651}51.04966717869943%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_2{19.559651817716333%{stroke-dashoffset: 1287}51.30568356374808%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_3{19.81566820276498%{stroke-dashoffset: 231}51.561699948796736%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_4{20.07168458781362%{stroke-dashoffset: 302}51.81771633384537%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_5{20.32770097286226%{stroke-dashoffset: 83}52.07373271889401%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_6{20.583717357910906%{stroke-dashoffset: 33}52.32974910394266%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_7{20.83973374295955%{stroke-dashoffset: 45}52.585765488991306%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_8{21.09575012800819%{stroke-dashoffset: 33}52.84178187403994%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_9{21.351766513056837%{stroke-dashoffset: 62}53.09779825908858%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_10{21.60778289810548%{stroke-dashoffset: 62}53.35381464413723%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_11{21.86379928315412%{stroke-dashoffset: 145}53.60983102918587%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_12{22.119815668202765%{stroke-dashoffset: 55}53.865847414234516%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_13{22.375832053251408%{stroke-dashoffset: 172}54.121863799283155%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_14{22.63184843830005%{stroke-dashoffset: 64}54.377880184331794%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_15{22.887864823348693%{stroke-dashoffset: 172}54.63389656938045%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_16{23.14388120839734%{stroke-dashoffset: 104}54.889912954429086%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_17{23.399897593445978%{stroke-dashoffset: 40}55.14592933947773%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_18{23.65591397849462%{stroke-dashoffset: 401}55.40194572452637%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_19{23.911930363543267%{stroke-dashoffset: 32}55.657962109575024%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_20{24.16794674859191%{stroke-dashoffset: 32}55.91397849462366%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_21{24.42396313364055%{stroke-dashoffset: 97}56.16999487967229%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_22{24.679979518689194%{stroke-dashoffset: 97}56.42601126472094%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_23{24.935995903737837%{stroke-dashoffset: 185}56.682027649769594%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_24{25.19201228878648%{stroke-dashoffset: 91}56.93804403481823%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_25{25.448028673835122%{stroke-dashoffset: 382}57.194060419866865%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_26{25.704045058883768%{stroke-dashoffset: 137}57.45007680491552%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_27{25.960061443932407%{stroke-dashoffset: 137}57.70609318996417%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_28{26.216077828981057%{stroke-dashoffset: 212}57.962109575012796%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_29{26.472094214029696%{stroke-dashoffset: 77}58.21812596006144%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_30{26.72811059907834%{stroke-dashoffset: 77}58.47414234511009%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_31{26.984126984126984%{stroke-dashoffset: 221}58.730158730158735%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_32{27.240143369175623%{stroke-dashoffset: 45}58.986175115207374%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_33{27.49615975422427%{stroke-dashoffset: 221}59.24219150025601%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_34{27.752176139272912%{stroke-dashoffset: 45}59.498207885304666%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_35{28.008192524321558%{stroke-dashoffset: 221}59.754224270353305%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_36{28.264208909370197%{stroke-dashoffset: 45}60.010240655401944%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_37{28.52022529441884%{stroke-dashoffset: 52}60.26625704045059%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_38{28.776241679467486%{stroke-dashoffset: 140}60.52227342549923%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_39{29.032258064516125%{stroke-dashoffset: 46}60.77828981054788%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_40{29.28827444956477%{stroke-dashoffset: 15}61.03430619559652%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_41{29.544290834613413%{stroke-dashoffset: 9}61.29032258064516%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_42{29.800307219662052%{stroke-dashoffset: 37}61.546338965693806%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_43{30.0563236047107%{stroke-dashoffset: 54}61.80235535074245%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_44{30.31233998975934%{stroke-dashoffset: 52}62.0583717357911%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_45{30.568356374807987%{stroke-dashoffset: 140}62.31438812083972%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_46{30.824372759856626%{stroke-dashoffset: 46}62.570404505888376%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_47{31.080389144905276%{stroke-dashoffset: 15}62.82642089093703%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_48{31.336405529953915%{stroke-dashoffset: 9}63.08243727598566%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_49{31.59242191500256%{stroke-dashoffset: 37}63.33845366103431%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_50{31.848438300051203%{stroke-dashoffset: 54}63.594470046082954%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_51{32.104454685099846%{stroke-dashoffset: 491}63.8504864311316%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_52{32.36047107014849%{stroke-dashoffset: 137}64.10650281618024%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_53{32.61648745519714%{stroke-dashoffset: 216}64.36251920122888%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_54{32.87250384024577%{stroke-dashoffset: 137}64.61853558627753%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_55{33.12852022529442%{stroke-dashoffset: 216}64.87455197132617%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_56{33.384536610343055%{stroke-dashoffset: 229}65.13056835637481%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_57{33.64055299539171%{stroke-dashoffset: 30}65.38658474142346%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_58{33.89656938044035%{stroke-dashoffset: 30}65.6426011264721%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_59{34.15258576548899%{stroke-dashoffset: 48}65.89861751152074%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_60{34.40860215053763%{stroke-dashoffset: 348}66.15463389656938%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_61{34.66461853558628%{stroke-dashoffset: 154}66.41065028161803%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}@keyframes EdzHxLGs_draw_62{34.92063492063492%{stroke-dashoffset: 551}66.66666666666666%{ stroke-dashoffset: 0;}100%{ stroke-dashoffset: 0;}}")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.71cba2af4eea00e0d0db23fa3195815e.svg";
export { ForwardRef as ReactComponent };